import explore from "./zh-CN/explore";
import filter from "./zh-CN/filter";

export default {
  ...explore,
  ...filter,
};
